<template>
    <div class="columns">
        <slot/>
        <div class="spacerColumn"></div>
    </div>
</template>

<style lang="scss">
@import "../../assets/variables.scss";

@media screen and (min-width: $tabletWidth) {
    .spacerColumn {
        display: block;
        flex-basis: 0;
        flex-grow: 1;
        flex-shrink: 1;
        padding: 0.75rem;
    }
}
</style>